import React from 'react';
import { motion } from 'framer-motion';
import { Beer, Factory, Building2 } from 'lucide-react';
const personas = [{
  icon: <Beer className="w-8 h-8" data-id="element-340" />,
  title: 'Beverage Producers',
  scale: 'Independent and craft',
  desc: 'Stop tying up cash in bottles and crates. Take what you need for a seasonal release or your core lineup, then scale it up when things take off.'
}, {
  icon: <Factory className="w-8 h-8" data-id="element-341" />,
  title: 'Food and CPG Brands',
  scale: 'Mid-market operators',
  desc: 'We handle returns across your whole distribution network, bottles, crates, and pallets, so your team can get back to making the product.'
}, {
  icon: <Building2 className="w-8 h-8" data-id="element-342" />,
  title: 'Industrial and Logistics',
  scale: 'Enterprise and supply chain',
  desc: 'Hit your ESG targets with numbers you can actually report. We help cut scope 3 emissions and keep tabs on every asset moving through your network.'
}];
export const Personas: React.FC = () => {
  return <section className="py-32 bg-surface" data-id="element-343">
      <div className="max-w-7xl mx-auto px-6 md:px-12" data-id="element-344">
        <div className="mb-16" data-id="element-345">
          <h2 className="font-display text-4xl md:text-5xl text-primary mb-6" data-id="element-346">
            From one taproom to a national footprint.
          </h2>
          <p className="text-lg text-ink/70 max-w-2xl" data-id="element-347">
            We work with one-location startups and multi-site operators alike.
            Take what you need this month, scale up the next, and never get
            stuck owning packaging you aren't using.
          </p>
        </div>

        <div className="grid md:grid-cols-3 gap-8" data-id="element-348">
          {personas.map((persona, index) => <motion.div key={index} initial={{
          opacity: 0,
          y: 20
        }} whileInView={{
          opacity: 1,
          y: 0
        }} viewport={{
          once: true
        }} transition={{
          delay: index * 0.1
        }} className="p-8 rounded-2xl border border-primary/5 bg-white shadow-glossy hover:shadow-glossy-lg hover:-translate-y-1 transition-all duration-300 gloss-card relative" data-id="element-349">
              <div className="relative" data-id="element-350">
                <div className="text-leaf mb-6" data-id="element-351">{persona.icon}</div>
                <h3 className="font-display text-2xl text-primary mb-2" data-id="element-352">
                  {persona.title}
                </h3>
                <div className="font-mono text-xs text-muted mb-4 uppercase tracking-wider" data-id="element-353">
                  {persona.scale}
                </div>
                <p className="text-ink/70 leading-relaxed" data-id="element-354">{persona.desc}</p>
              </div>
            </motion.div>)}
        </div>
      </div>
    </section>;
};